import axios from 'axios'
let headers = {
    'content-type': 'application/json',
    'sec-fetch-mode':'cors',
    'sec-fetch-site':'cross-site'

}
const axiosIntance = axios.create({
    baseURL: "https://api.voip24h.vn/vn-provinces/api/v1/",
    headers: headers
})

// axiosIntance.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('accessToken');
//         if(token) {
//             config.headers.Authorization = `Bearer ${token}`
//         }
//         return config
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

axiosIntance.interceptors.response.use(
    (response) => {
        return response;        
    }, 
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosIntance